export const QueueBindings = {
	SERVICE_WORKER_PREFIX: "MINIFLARE_WORKER_",
	MAYBE_JSON_QUEUE_PRODUCERS: "MINIFLARE_QUEUE_PRODUCERS",
	MAYBE_JSON_QUEUE_CONSUMERS: "MINIFLARE_QUEUE_CONSUMERS",
} as const;
